import Component from '../abstracts/Component';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class ShowPasswordComponent extends Component {

  get SELECTORS() {
    return {
      toggle: '.toggle-password',
    };
  }

  get CLASSES() {
    return {
      passwordVisible: 'icon-visibility-on',
      passwordNotVisible: 'icon-visibility-off'
    };
  }

  get COMPONENTNAME() {
    return 'ShowPasswordComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.toggle = this.$component.querySelector(this.SELECTORS.toggle);
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
  }

  bindEvents() {
    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const input = e.currentTarget.parentElement.querySelector('input');
      const inputType = input.getAttribute('type');

      if (!input.value) return;

      switch (inputType) {
        case 'password':
          input.setAttribute('type', 'text');
          event.currentTarget.classList.remove(this.CLASSES.passwordVisible);
          event.currentTarget.classList.add(this.CLASSES.passwordNotVisible);
          this.liveRegion.sayMessage(this.toggle.dataset.showPasswordMsg);
          break;
        case 'text':
          input.setAttribute('type', 'password');
          event.currentTarget.classList.remove(this.CLASSES.passwordNotVisible);
          event.currentTarget.classList.add(this.CLASSES.passwordVisible);
          this.liveRegion.sayMessage(this.toggle.dataset.hidePasswordMsg);
          break;
      }
    });
  }

  render() {
    this.log("Rendering...")
    this.bindEvents();
  }
}
